const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

// Drops the front-end-only 'UNASSIGNED' tray id: the stops endpoints bind List<UUID>, and one non-UUID rejects the whole body.
export const toRequestableRouteIds = (routeIds: readonly unknown[] = []): string[] =>
  routeIds.filter((id): id is string => typeof id === 'string' && UUID_PATTERN.test(id)).sort()

export default toRequestableRouteIds
